import { ReactNode } from "react";

import PageWrapper from "components/PageWrapper";
import PageInfoHeader from "ds/components/PageInfoHeader";

type SpacesPageLayoutProps = {
  children: ReactNode;
};

const SpacesPageLayout = ({ children }: SpacesPageLayoutProps) => {
  return (
    <>
      <PageInfoHeader title="Spaces" />
      <PageWrapper>{children}</PageWrapper>
    </>
  );
};

export default SpacesPageLayout;
